const WIDGET_ID = "result-esg-distribution";

export { WIDGET_ID };
